import React from "react"
import { Fragment } from "react"
import { useNavigate } from "react-router"
import { useParams, useLocation } from "react-router-dom"
import {
  Button,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import DependantsBeneficiaryProfile from "./dependantsTabs/profile"
import DependantsPersonalDetails from "./dependantsTabs/personalDetails"

const DependantsProfile = () => {
  const [activeTab, setActiveTab] = React.useState("1")
  const location = useLocation()

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  const navigate = useNavigate()
  const params = useParams()

  return (
    <Fragment>
      <Container fluid>
        <div className="page-content">
          <div>
            <div className="d-flex justify-content-between">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={activeTab === "1" ? "active text-primary" : ""}
                    onClick={() => {
                      toggle("1")
                    }}
                  >
                    Dependants's Beneficiary Profile
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "2" ? "active text-primary" : ""}
                    onClick={() => {
                      toggle("2")
                    }}
                  >
                    Personal Details
                  </NavLink>
                </NavItem>
              </Nav>
              <Button
                onClick={() => {
                  navigate(-1)
                }}
                className="w-25 bg-info border-0"
              >
                Back
              </Button>
            </div>

            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <div className="mt-5">
                  <DependantsBeneficiaryProfile />
                </div>
              </TabPane>
              <TabPane tabId="2">
                <div className="mt-5">
                  <DependantsPersonalDetails />
                </div>
              </TabPane>
            </TabContent>
          </div>
        </div>
      </Container>
    </Fragment>
  )
}

export default DependantsProfile
